// Public read-only doc — no auth, reached via /shared/doc/:token
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import { docsAPI } from '../lib/api';
import { fmtDateTime } from '../components/ui';
import { useBrand } from '../hooks/useBrand';

export default function PublicDoc() {
  const { token } = useParams();
  const brand = useBrand();
  const [doc, setDoc] = useState(null);
  const [error, setError] = useState('');

  const editor = useEditor({
    extensions: [StarterKit],
    editable: false,
    editorProps: { attributes: { class: 'pm-doc text-sm leading-relaxed outline-none' } },
  });

  useEffect(() => {
    if (!editor) return;
    docsAPI
      .public(token)
      .then(({ data }) => {
        setDoc(data);
        editor.commands.setContent(data.content || { type: 'doc', content: [] });
      })
      .catch(() => setError('This link is invalid or has been disabled.'));
  }, [token, editor]);

  if (error) {
    return <div className="flex min-h-screen items-center justify-center text-sm text-pm-muted">{error}</div>;
  }
  if (!doc) return null;

  return (
    <div className="mx-auto max-w-2xl px-6 py-10">
      <div className="mb-6 border-b border-pm-border pb-4">
        <h1 className="text-xl font-semibold">{doc.title}</h1>
        <p className="mt-1 text-xs text-pm-faint">Shared from {brand.wordmark} · updated {fmtDateTime(doc.updated_at)}</p>
      </div>
      <EditorContent editor={editor} />
    </div>
  );
}
